import { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import styles from './fund-detail-buttons.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import Icon from '../../../atoms/icon';
import DropdownBasic from '../../../atoms/dropdown-basic';
import InteractiveElement from '../../../atoms/interactive-element';
import PropTypes from 'prop-types';
import {
  fetchDocumentsData,
  fetchDisclosuresData
} from '../../../../stores/screener/actions/row-documents-disclosures-actions';
import screenerAppContext from '../../../../stores/screener/screener-app-context';
import Spinner from '../../../atoms/spinner';

const className = augmentClassName(styles);

export const FundDetailButtons = ({
  setModal,
  fundType,
  xid,
  item,
  documentsObj,
  fundDisclosures,
  fundName,
  fundTicker,
  getDocuments,
  getFundDisclosures,
  documentsLoading
}) => {
  const { yyy, channel } = useContext(screenerAppContext);
  const [documents, setDocuments] = useState([]);
  const onButtonClick = (url, urlList, label) => {
    if (urlList && urlList.length > 0) {
      setModal('Fact Sheets', urlList);
    } else if (label === 'Prospectus') {
      window.open(url, '_blank', 'location=yes,noopener,noreferrer');
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  useEffect(() => {
    if (documentsObj && Object.keys(documentsObj).length > 0 && documentsObj[xid]) {
      setDocuments(documentsObj[xid]);
    }
  }, [documentsObj]); // eslint-disable-line react-hooks/exhaustive-deps

  const openDisclosures = async () => {
    const disclosure = await getFundDisclosures(xid, item, yyy, channel);
    if (fundDisclosures[xid] || disclosure) {
      setModal('Disclosure', fundDisclosures[xid] || disclosure);
    }
  };

  return (
    <div {...className('btn-container')}>
      <DropdownBasic items={documents} loading={documentsLoading}>
        <DropdownBasic.Trigger
          {...className('dropDown-trigger')}
          onMouseDown={() => {
            getDocuments(fundType, xid, yyy, channel);
          }}
          aria-label={`ticker ${fundTicker} document dropdown`}
        >
          <Icon variant="documentScreener" />

          <span
            {...className('btn-text')}
            // TIAA Analytics Tracking
            data-analytics-linkname={`${fundName} [${fundTicker}]:InvestmentResults:Documents`}
            data-analytics-section="component"
            data-analytics-componenttype="Link"
            // END TIAA Analytics Tracking
          >
            Documents
          </span>
        </DropdownBasic.Trigger>
        <DropdownBasic.Item {...className('position-relative')}>
          {document => (
            <InteractiveElement
              as = 'a'
              {...className('text-decoration-none', 'stretched-link', 'text-black')}
              role="button"
              onClick={() => onButtonClick(document.url, document.urlList, document.label)}
            >
              {document.label}
            </InteractiveElement>
          )}
        </DropdownBasic.Item>
      </DropdownBasic>
      <InteractiveElement
        as='button'
        {...className('btn-disclosure', 'btn-reset')}
        onClick={async () => await openDisclosures()}
        aria-label="open disclosure popup"
      >
        <Icon variant={'disclosureScreener'} style={{ color: '#0067B9' }} />
        <span
          {...className('btn-disclosure-label')}
          // TIAA Analytics Tracking
          data-analytics-linkname={`${fundName} [${fundTicker}]:InvestmentResults:Disclosure}`}
          data-analytics-section="component"
          data-analytics-componenttype={'Modal'}
          // END TIAA Analytics Tracking
        >
          Disclosure
        </span>
      </InteractiveElement>
      <Spinner />
    </div>
  );
};

FundDetailButtons.propTypes = {
  setModal: PropTypes.func,
  fundType: PropTypes.string,
  xid: PropTypes.number,
  item: PropTypes.object,
  documentsObj: PropTypes.object,
  fundDisclosures: PropTypes.object,
  fundName: PropTypes.string,
  fundTicker: PropTypes.string,
  getDocuments: PropTypes.func,
  getFundDisclosures: PropTypes.func,
  documentsLoading: PropTypes.bool
};

FundDetailButtons.defaultProps = {
  fundDisclosures: {}
};

const mapDispatchToProps = dispatch => {
  return {
    getDocuments: (fundType, xid, yyy, channel) =>
      dispatch(fetchDocumentsData(fundType, xid, yyy, channel)),
    getFundDisclosures: (xid, item, yyy, channel) =>
      dispatch(fetchDisclosuresData(xid, item, yyy, channel))
  };
};

const mapStateToProps = state => {
  return {
    documentsObj: state.rowDocsAndDisclosuresReducer.documents,
    fundDisclosures: state.rowDocsAndDisclosuresReducer.disclosures,
    documentsLoading: state.rowDocsAndDisclosuresReducer.documentsLoading
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FundDetailButtons);
